var map = {
	"./arrow-down.svg": "5860",
	"./arrow-left.svg": "379e",
	"./arrow-left2.svg": "a7c5",
	"./arrow-right.svg": "895b",
	"./arrow-right2.svg": "10e8",
	"./chart.svg": "ad6c",
	"./close.svg": "872d",
	"./close2.svg": "40be",
	"./components.svg": "0ac0",
	"./control.svg": "3791",
	"./detail.svg": "d06b",
	"./edit.svg": "3b3b",
	"./editor.svg": "f6f2",
	"./home.svg": "fb0a",
	"./icon.svg": "c1c6",
	"./language-outline.svg": "50f6",
	"./list.svg": "1709",
	"./more.svg": "ef4e",
	"./page.svg": "c20d",
	"./permissions.svg": "066f",
	"./refresh.svg": "2bb5",
	"./set.svg": "7595"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "742a";